import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { SurveyRoutes } from 'src/routes'
import ScrollTopButton from 'src/features/ScrollTopButton'
import Header from 'src/features/Header'
import Footer from 'src/features/Footer'
import Content from './Content'

function SurveyLayout() {
  const navigate = useNavigate()
  const token = window.sessionStorage.getItem('token')

  useEffect(() => {
    if (!token) {
      navigate('/', { replace: true })
    }
  }, [token])

  if (!token) return null

  return (
    <div className="d-flex flex-column vh-100">
      <Header />
      <div className="flex-grow-1">
        <Content routes={SurveyRoutes} />
      </div>
      <Footer />
      <ScrollTopButton />
    </div>
  )
}

export default SurveyLayout
